<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <div class="admin-content-frame">
        <router-view></router-view>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>

<style scoped>
.admin-content-frame {
  max-width: 1680px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue